/**
 * Wheel Theme Selector Options
 * For use in Polaris Select components
 */

import type { WheelThemeId } from './wheelThemes';

export const WHEEL_THEME_OPTIONS: Array<{ label: string; value: WheelThemeId }> = [
  { label: "Modern (Recommended)", value: "modern" },
  { label: "Minimal", value: "minimal" },
  { label: "Classic", value: "classic" },
  { label: "Festive", value: "festive" },
  { label: "Beauty (Rose Quartz Luxe)", value: "beauty_rose_quartz_luxe" },
];
